module.exports = __webpack_public_path__ + "media/images/firsttime_contents02_pc-16a7715d5fb7c4e25bb860bb029cc101.png";